/* ==========================================================================
   Pettu — mantém preço, parcelamento e Pix em dia na troca de variante.

   Por que existe: o product-info.js do Dawn só troca os elementos de id
   price-, Sku-, Inventory-, Volume- e Price-Per-Item- (ver
   updateSourceFromDestination). Blocos Liquid personalizados ficam de fora e
   congelam no preço da primeira variante — o cliente escolhe "3un", o preço
   sobe, e o parcelamento continua mostrando o valor do "1un".

   Como resolve: o evento variantChange já carrega o HTML novo da seção.
   Basta aproveitar e trocar o conteúdo dos nossos blocos. Nada de recalcular
   dinheiro em JavaScript — o valor vem formatado do servidor, com o mesmo
   formato de moeda da loja.
   ========================================================================== */

(function () {
  var BLOCOS = ['.pettu-preco', '.pettu-parcelas', '.pettu-pix'];

  function sincronizar(evento) {
    var html = evento && evento.data && evento.data.html;
    if (!html) return;

    BLOCOS.forEach(function (seletor) {
      var origem = html.querySelector(seletor);
      var destino = document.querySelector(seletor);
      if (!origem || !destino) return;
      destino.innerHTML = origem.innerHTML;
    });
  }

  function ligar() {
    // pubsub.js carrega com defer; se ainda não estiver pronto, não há o que fazer
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, sincronizar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar);
  } else {
    ligar();
  }
})();
